import React from 'react';
import PropTypes from 'prop-types';
import UserService from '../../../../../services/user.service';

const User = ({
  src,
  item,
  chatName,
  lastMessage,
  activeId,
  classNaming,
  backgroundColor,
}) => (
  <div className={classNaming + (activeId === item.id ? ' active' : '')}>
    <div className={`user-img ${backgroundColor}`}>
      <img src={src} alt="msg" className="tc" onError={(e) => { e.target.src = UserService.defaultAvatar; }} />
      {/*{is_online ? <img src="/img/online-dot.svg" alt="online" className="online-dot" /> : ''}*/}
      {item.unread_count ? <span className="msgnumber msgnumber_conv">{item.unread_count}</span> : ''}
    </div>
    <div className={`user-text ${backgroundColor}` || ''}>
      <h6 className={`user-info three-dots ${backgroundColor ? 'tc' : ''}`}>{chatName}</h6>
      <p className="user-message user-info three-dots">{lastMessage}</p>
    </div>
  </div>
);

User.propTypes = {
  src: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  backgroundColor: PropTypes.string,
  classNaming: PropTypes.string.isRequired,
};

export default User;



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/user/User.jsx